const assetActionTypes = {
  FETCH_SAVED_OPTIONS: 'FETCH_SAVED_OPTIONS',
  FETCH_SAVED_OPTIONS_SUCCESS: 'FETCH_SAVED_OPTIONS_SUCCESS',
  UPSERT_SAVED_OPTIONS: 'UPSERT_SAVED_OPTIONS',
  DELETE_SAVED_OPTION: 'DELETE_SAVED_OPTION',
};
export default assetActionTypes;
